import React, { Component } from "react";
import * as actionReducers from "../../reducers";
import {connect} from "react-redux";
import * as ActionCreators from "../../actions";
import {Link} from 'react-router-dom';

class AboutUs extends Component {

    componentDidMount() {
        //this.props.findStoryDetails(storyId);
    }
    render() {
        //let story = this.props.storyDetails.data;

        return (
            <React.Fragment>

                <div className="anchor-links">
                    <Link onClick={(e) => this.props.changeSection('')}>Home</Link>  /  <Link className="current-page">About Us</Link>
                </div>

                <div class="boiler-panel">
                    <div class="boiler-banner">
                        <h5>About Us</h5>
                    </div>
                    <div className="boiler-content"
                         dangerouslySetInnerHTML={{__html: this.props.pageContents['About Us'] ? this.props.pageContents['About Us'].replace(/<p><br><\/p>/gm, '').replace(/<p>&nbsp;<\/p>/gm, '') : ''}}>
                    </div>
                    </div>



            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        loader: actionReducers.getLoader(state),
        storyDetails: actionReducers.getStoryDetails(state),
    }
}
export default connect(mapStateToProps, {
    findStoryDetails: ActionCreators.findStoryDetails
})(AboutUs);
